export default __webpack_public_path__ + "static/media/chutney_powder.c0612132.png";